import { ConnectFailure, ConnectFailureType } from '@src/utils/auth/oauth-client';

interface FailureCopy {
  title: string;
  body: string;
}

// Fixed copy per failure. The page never shows a value taken from the URL, only a key into this map.
export const FAILURE_COPY: Record<ConnectFailureType, FailureCopy> = {
  [ConnectFailure.REDIRECT]: {
    title: "We couldn't connect this app",
    body: 'The app asked to be sent to an address that is not registered for Blisspoint, so nothing was sent there. Check that you are using a supported app and its current setup instructions.'
  },
  [ConnectFailure.SIGNIN_FAILED]: {
    title: 'Sign-in failed',
    body: 'We could not complete your sign-in. Return to the app and start the connection again.'
  },
  [ConnectFailure.EXPIRED]: {
    title: 'This sign-in expired',
    body: 'The connection request timed out or was opened in a different browser. Return to the app and start the connection again.'
  },
  [ConnectFailure.UNKNOWN]: {
    title: "This link isn't valid",
    body: 'Return to the app you are connecting and start again.'
  }
};

export const CONSENT_LOADING_LABEL = 'Connecting...';
